var React = require('react');

function Dismiss (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h32v32H0z","key":0}),React.createElement("g",{"fill":"#FFF","fillRule":"nonzero","strokeLinecap":"round","strokeLinejoin":"round","key":1},[React.createElement("path",{"d":"M21.293 9.293l-12 12a1 1 0 0 0 1.414 1.414l12-12a1 1 0 1 0-1.414-1.414z","key":0}),React.createElement("path",{"d":"M22.707 21.293l-12-12a1 1 0 0 0-1.414 1.414l12 12a1 1 0 0 0 1.414-1.414z","key":1}),React.createElement("path",{"d":"M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm0-2C8.268 30 2 23.732 2 16S8.268 2 16 2s14 6.268 14 14-6.268 14-14 14z","key":2})])]));
}

Dismiss.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Dismiss;

Dismiss.default = Dismiss;
